import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-radio-group',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './radio-group.html',
  styleUrl: './radio-group.css'
})
export class RadioGroup {
  @Input() options: { label: string; value: any }[] = [];
  @Input() selectedValue: any = null;
  @Output() selectedValueChange = new EventEmitter<any>();

  onSelect(value: any) {
    this.selectedValue = value;
    this.selectedValueChange.emit(value);
  }
}
